import { SubChartType } from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/sdk-model.interface';
import { BaseSubChart } from '@src/slide/domain/ui-model/element-modeles/chart-models/sub-chart/base-sub-chart';
import { PresetChartType } from '../chart-presets/const';
import type {
    IBubbleChartSeries,
} from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/sub-chart/bubble-chart.interface';
import type { STSizeRepresents } from '@tencent/slide-sdk-model';
import type { IBubbleChart } from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/sub-chart';

export class BubbleChart extends BaseSubChart implements IBubbleChart {
    public static convertDataUiToSdk(uiData, sdkData, rawUiData): void {
        this.convertSubChartUiToSdkByType(SubChartType.BubbleChart, uiData, sdkData, rawUiData);
    }
    public type = SubChartType.BubbleChart;
    public bubble3D: boolean;
    // 气泡图缩放比例，介于0-300，默认100，即无缩放
    public bubbleScale: number;
    // 是否显示负值气泡
    public showNegBubbles?: boolean;
    // 气泡大小表示为气泡面积或气泡宽度,值为：area, w，默认是area
    public sizeRepresents: STSizeRepresents;

    public declare series: IBubbleChartSeries[];

    public getPresetChartType(): PresetChartType {
        return PresetChartType.BUBBLE;
    }
}
